import React from 'react'
import useSelector from 'hooks/use-selector'

import EditRatingBottomSheet from 'containers/QuickShopProductSidebar/components/EditRatingBottomSheet'

import useDispatch from 'hooks/use-dispatch'
import toggleProductVariantRatingStatusAction from 'modules/product/redux/actions/toggle-product-variant-rating-status'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import getFullSizeFromConversionProductVariantSelector from 'modules/product-variant/redux/selectors/get-correct-full-size-from-conversion'
import updateCurrentVariantIdAction from 'modules/variant/redux/actions/update-current'
import updateIsSampleVariantIdAction from 'modules/variant/redux/actions/update-is-sample'
import updateSelectedColorVariantIdVariantAction from 'modules/variant/redux/actions/update-selected-color-variant-id'
import addProductAndVariantIdToUrlProductUtil from 'modules/product/utils/add-product-and-variant-id-to-url'
import addSelectedVariantIdToUrlProductUtil from 'modules/product/utils/add-selected-variant-id-to-url'
import useIsSmallScreen from 'hooks/use-is-small-screen'
import isProductUrlLocationUtil from 'utils/location/is-product-url'
import Modal from 'containers/Modal'
import { MODAL_ID } from 'modules/modal/redux/constants'

const ANALYTICS_EVENT = {
  RATE_LIKE_FROM_QUICK_SHOP: 'RATE_LIKE_FROM_QUICK_SHOP',
  RATE_DISLIKE_FROM_QUICK_SHOP: 'RATE_DISLIKE_FROM_QUICK_SHOP'
}

const QuickShopProductSidebarButtonHandleRating = ({
  productVariant,
  variantId,
  onClose,
  openAddFullSizeModal,
  isBottomSheetOpen
}) => {
  const dispatch = useDispatch()

  const fullSizeFromConversionProductVariant = useSelector(
    getFullSizeFromConversionProductVariantSelector({
      productVariant
    })
  )

  const isSmallScreen = useIsSmallScreen()
  const isFromProductPage = isProductUrlLocationUtil()

  const loadFullSizeConversionInsideQuickShop = () => {
    dispatch(updateCurrentVariantIdAction(productVariant?.fullsize_variant_id))
    dispatch(updateIsSampleVariantIdAction(false))

    addProductAndVariantIdToUrlProductUtil({
      productId: productVariant.product_id,
      variantId: productVariant?.fullsize_variant_id
    })

    dispatch(
      updateSelectedColorVariantIdVariantAction({
        variantId: fullSizeFromConversionProductVariant?.fullsize_variant_id,
        shouldUpdateMediaGallery: true,
        fromSidebar: true
      })
    )

    addSelectedVariantIdToUrlProductUtil({
      selectedVariantId: fullSizeFromConversionProductVariant?.fullsize_variant_id
    })
  }

  const onClickLikeSample = async () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.RATE_LIKE_FROM_QUICK_SHOP)
    onClose()
    await dispatch(
      toggleProductVariantRatingStatusAction({
        variantId,
        productId: productVariant.product_id,
        rating: 'like'
      })
    )
    openAddFullSizeModal()
    loadFullSizeConversionInsideQuickShop()
  }

  const onDislikeSample = async () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.RATE_DISLIKE_FROM_QUICK_SHOP)
    onClose()
    await dispatch(
      toggleProductVariantRatingStatusAction({
        variantId,
        productId: productVariant.product_id,
        rating: 'not_like'
      })
    )
    loadFullSizeConversionInsideQuickShop()
  }

  const RenderEditRating = () => {
    if (!isFromProductPage || isSmallScreen) {
      return (
        <EditRatingBottomSheet
          label='Rate sample'
          onLike={onClickLikeSample}
          onDislike={onDislikeSample}
          onClose={onClose}
        />
      )
    }

    return (
      <Modal
        onRequestClose={onClose}
        id={MODAL_ID.EDIT_RATING}
      >
        <div
          className='edit-rating-modal-container'
          onClick={onClose}
        >
          <EditRatingBottomSheet
            label='Rate sample'
            onLike={onClickLikeSample}
            onDislike={onDislikeSample}
            onClose={onClose}
          />
        </div>
      </Modal>
    )
  }

  return (
    <div>
      {isBottomSheetOpen && <RenderEditRating />}
    </div>
  )
}

export default QuickShopProductSidebarButtonHandleRating
